import axios from 'axios'
import { message, Modal } from 'ant-design-vue'
import { router } from '@/router/index'

// 接口前缀：读取 public/config.js 中的运行时配置，默认 '/prod-api'（同源，由 Nginx 代理到后端）
// 部署后如需更换后端地址，直接修改站点根目录下的 config.js 即可，无需重新打包
const baseURL = window.__HL_API_BASE__ || '/prod-api'

const services = axios.create({
  baseURL,
  timeout: 10 * 1000,
})

export { baseURL }
// 请求拦截
services.interceptors.request.use(
  (config) => {
    const token = window.sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截
services.interceptors.response.use(
  (response) => {
    const res = response.data

    if (res.code !== 200) {
      if (res.code === 401) {
        const token = window.sessionStorage.getItem('token')

        window.sessionStorage.removeItem('token')
        if (token) {
          Modal.info({
            title: '您的登录已过期',
            content: '点击确定刷新页面',
            okText: '确定',
            onOk() {
              window.location.reload()
            },
          })
        } else {
          message.error('未登录')
          router.replace('/')
        }
        return Promise.reject('登录过期')
      }
      const msg = res.msg || '未知错误，请联系管理员查看'

      console.error('[api]', msg)

      /** @type {RequestConfig} */
      const config = response.config
      if (config.isShowError) {
        message.error(msg.length < 50 ? msg : '请求错误，请联系管理员查看')
      }

      return Promise.reject(msg)
    }

    // return res.data
    return res
  },
  (error) => {
    const { response } = error
    if (response && response.data) {
      return Promise.reject(error)
    } else {
      const { message } = error
      console.error('[api]', message)
      return Promise.reject(error)
    }
  }
)

export default services
